import ButtonSave from "@View/components/buttons/ButtonSave";
import DefaultInput from "@View/components/formInputs/DefaultInput";
import ModalTittle from "@View/components/ModalTittle";
import ModalWrapper from "@View/components/ModalWrapper";
import React, { useCallback, useState } from "react";
import getAPI from "@API/index";
import { useSelector } from "react-redux";
import { FetchOnceAutocompleteMultiple } from "@Components/form/control/FetchOnceAutocompleteMultiple";
import { useTranslation } from "react-i18next";

const NewGroupModal = ({
  customerId,
  open,
  handleOpen,
  handleClose,
  handleUpdate,
  groups = [],
}) => {
  const { t } = useTranslation();
  const [newData, setNewData] = React.useState({
    name: "",
  });
  const handleChange = (value, label) => {
    setNewData({ ...newData, [label]: value });
  };
  const [clientError, setClientError] = useState(false);
  const [clientVal, setClientVal] = useState([]);
  const clients = useSelector(
    (state) => state.customer?.customer?.clients ?? []
  );

  // Get all client IDs that are already in groups
  const clientsInGroups = React.useMemo(() => {
    const ids = new Set();
    groups.forEach((group) => {
      (group.clients || []).forEach((client) => {
        ids.add(client.id);
      });
    });
    return ids;
  }, [groups]);

  const searchClients = useCallback(async () => {
    // Filter only clients that are not in any group
    return clients
      .filter((client) => !clientsInGroups.has(client.id))
      .map((client) => ({
        id: client.id,
        name: client.name,
      }));
  }, [clients, clientsInGroups]);

  const handleClientChange = (newValue) => {
    setClientVal(newValue);
    // Clear error when user selects a value
    if (clientError && newValue.length > 0) {
      setClientError(false);
    }
  };

  const createNewGroup = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (clientVal.length === 0) {
      setClientError(true);
      return;
    }
    getAPI()
      .request({
        method: "post",
        url: `/api/Customer/${customerId}/groups`,
        data: { ...newData, clients: clientVal },
        successText: "snackbar.success",
      })
      .then(() => {
        handleClose();
        handleUpdate();
      });
  };

  return (
    <ModalWrapper open={open} handleOpen={handleOpen} handleClose={handleClose}>
      <form onSubmit={(event) => createNewGroup(event)}>
        <ModalTittle>h1.NewGroup</ModalTittle>
        <DefaultInput
          value={newData.name}
          label="inputs.GroupName"
          onChange={(value) => handleChange(value, "name")}
        />
        <FetchOnceAutocompleteMultiple
          value={clientVal}
          id="ClientCapacity"
          label={t("ClientCapacity")}
          fetchOptions={searchClients}
          onChange={handleClientChange}
          error={clientError}
          helperText={clientError ? t("FieldRequired") : ""}
        />
        <ButtonSave>buttons.Save</ButtonSave>
      </form>
    </ModalWrapper>
  );
};

export default NewGroupModal;
